import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Sentry from '@sentry/react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { IntercomProvider } from 'react-use-intercom';

Sentry.init({
  dsn: window.checkoutConfig.sentry_dsn,
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <IntercomProvider appId="j4tr2hf6">
      <Router>
          <Switch>
            <Route path="/memberships" component={App} />
          </Switch>
      </Router>
    </IntercomProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
